export const locale = {
  lang: 'en',
  data: {
    NAV: {
      ADMIN: 'Admin',
      USER: 'User',
      USERS_MANAGEMENT: 'Agents management',
      PROFILE: 'Profile',
      ACCOUNT: 'Account',
      MASTER: 'Master',
      SELLER: {
        PROFILE: 'Personal profile',
        INVOICE: 'Invoice',
        INVOICE_ADD: 'Draft',
        INVOICE_EVALUATION: 'Under processing',
        INVOICE_EVALUATION_ALL: 'All',
        INVOICE_EVALUATION_PENDING_DEBTOR_VALIDATION: 'Debtor validation pending',
        INVOICE_EVALUATION_PENDING_INVOICE_VALIDATION: 'Checking data and documents',
        INVOICE_EVALUATION_READY: 'Ready for sale',
        INVOICE_EVALUATION_INVALID: 'Not transferable',
        INVOICE_PENDING: 'Pending approval',
        INVOICE_REJECTED: 'Rejected',
        INVOICE_SOLD: 'Sold',
        INVOICE_SOLD_ACTIVE: 'Pending debtor payment',
        INVOICE_SOLD_ARCHIVED: 'Payed',
        AUCTION: 'Auction',
        AUCTION_ALL: 'All',
        AUCTION_IN_PROGRESS: 'On auction',
        AUCTION_SOLD: 'Sold',
        AUCTION_EXPIRED: 'Not sold',
        CLIENT: 'Client analysis',
        DOCUMENT: 'Documents',
        DOCUMENT_AML: 'AML documents',
      },
      BUYER: {
        PROFILE: 'Personal profile',
        AUCTIONS_PROGRESS: 'Auctions in progress',
        AUCTIONS_CURRENT: 'Current',
        AUCTIONS_FUTURE: 'Future',
        AUCTIONS_AWARDED: 'Auctions awarded',
        AUCTIONS_AWARDED_ALL: 'All',
        AUCTIONS_AWARDED_PENDING_DOWNPAYMENT: 'Waiting for downpayment',
        AUCTIONS_AWARDED_PENDING_SETTLEMENT: 'Waiting for settlement',
        AUCTIONS_ALL: 'All',
        AUCTIONS_DEPOSIT: 'Deposit to be paid',
        AUCTIONS_BALANCE: 'Balance to be paid',
        FINALIZE_MATTERS: 'Finalize matters',
      },
      PARTNER: {
        AUCTIONS: 'Auctions',
        AUCTION_REPORT: 'Invoices Given',
        AUCTION_EXPIRED: 'Invoices not Sold',
        SOLD_PENDING_SETTLEMENT: 'Sold pending settlement',
        SOLD_PAYMENT_EXPIRED: 'Sold payment expired',
        COMPANIES: 'Companies',
      },
      PARTNER_PROFILE_TYPE: {
        PARTNER: 'Master',
        PARTNER_BRANCH_MANAGER: 'Branch Manager',
        PARTNER_AGENT: 'Agent',
      },
    },
  },
};
